'use client';

import { useEffect, useMemo, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { useStore } from 'zustand';

import { PatientSelectionModal } from './patient-selection-modal.component';
import { buildPatientOptions } from './_utils/build-patient-options.util';

import { authStore } from '@/store/auth.store';
import {
  closePatientSelection,
  patientSelectionStore,
  selectPatient,
} from '@/store/patient-selection/patient-selection.store';

export function PatientSelectionHost() {
  const isOpen = useStore(patientSelectionStore, (state) => state.isOpen);
  const request = useStore(patientSelectionStore, (state) => state.request);
  const authenticatedUser = useStore(authStore, (state) => state.authenticatedUser);

  const pathname = usePathname();
  const prevPathnameRef = useRef(pathname);

  useEffect(() => {
    if (prevPathnameRef.current === pathname) {
      return;
    }

    prevPathnameRef.current = pathname;
    closePatientSelection();
  }, [pathname]);

  const ageRange = useMemo(
    () => ({ minAge: request?.ageRange.minAge, maxAge: request?.ageRange.maxAge }),
    [request?.ageRange.minAge, request?.ageRange.maxAge],
  );

  const patients = useMemo(
    () => buildPatientOptions(authenticatedUser, ageRange),
    [authenticatedUser, ageRange],
  );

  return (
    <PatientSelectionModal
      open={isOpen}
      patients={patients}
      ageRange={ageRange}
      onClose={closePatientSelection}
      onSelectPatient={selectPatient}
    />
  );
}
